<script>
    import Router from 'svelte-spa-router'
    import Home from "./Home.svelte";
    import Docs from "./Docs.svelte";
    import Examples from "./Examples.svelte";
	import Install from './Install.svelte';
    import Sq from "./Sq_editor.svelte";
    import Sqi from "./Sq_editorI.svelte";
	

    const routes = {
        '/': Home,
        '/docs': Docs,
        '/examples': Examples,
        '/install': Install,
        '/sq': Sq,
        '/sqi': Sqi,
        '*': Home
    };
</script>

<Router routes={routes}/>